import { useState } from "react";
import { toast } from "react-hot-toast";
import usePut from "../usePut";
import { set } from "lodash";

const useGeneratePassword = ({ company_employee_id, onClose }) => {
  // States
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Save password API endpoint
  const { handleAuth: savePassword } = usePut({
    url: "set_password",
    refreshUrl: 'employeelist',
    onSuccess: () => {
      toast.success("Password saved successfully");
      setIsSubmitting(false);
      onClose();
    },
    onError: (error) => {
      toast.error("Failed to save password");
      setIsSubmitting(false);
      console.error("Password save error:", error);
    },
  });

  // Handle password change
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  // Handle save password
  const handleSavePassword = () => {
    if (!password.trim()) {
    //   toast.error("Please enter a password");
      setPasswordError("Please enter a password");
      return;
    }

    if (password.length < 8) {
    //   toast.error("Password must be at least 8 characters long");
      setPasswordError("Password must be at least 8 characters long");
      return;
    }

    setIsSubmitting(true);

    const payload = {
      company_employee_id: company_employee_id,
      password: password,
    };

    savePassword.mutate(payload);
  };

  const handleGeneratePassword = () => {
    const randomPassword = Math.random().toString(36).slice(-8);
    setPassword(randomPassword);
  };

  return {
    // States
    password,
    showPassword,
    isSubmitting,
    passwordError,

    // Functions
    togglePasswordVisibility,
    handlePasswordChange,
    handleSavePassword,
    handleGeneratePassword,
  };
};

export default useGeneratePassword;
